/**
 * @param {Object} args
 * @param {number} args.price
 * @param {number} args.quantity
 * @param {Object} args.offer
 */
export function calcQuantityDiscountPrice(args) {
  const { price, quantity, offer } = args;

  if (quantity < offer.quantityFrom) {
    console.log("calcQuantityDiscountPrice:quantity is less than quantityFrom");
    return price;
  }

  if (offer.quantityTo && quantity > offer.quantityTo) {
    console.log(
      "calcQuantityDiscountPrice:quantity is greater than quantityTo"
    );
    return price;
  }

  if (offer.amountType === "PERCENTAGE") {
    console.log(price, offer.amount, (price * (100 - offer.amount)) / 100);
    return (price * (100 - offer.amount)) / 100;
  } else if (offer.amountType === "FIXED_AMOUNT") {
    return price - offer.amount;
  } else if (offer.amountType === "FIXED_PRICE") {
    return Number(offer.amount);
  }

  console.log("calcQuantityDiscountPrice:discount not applied");

  return Number(price);
}
